angular.module('autoremind.reseller.services', [])
    .factory('resellerService', ['$http', '$enhancedHttp',
    function ($http, $enhancedHttp) {
        var resellerService = {
            viewModel: {
                stats: {
                    trialCust: 0,
                    customerCount: 0,
                    payingCust: 0
                },
                isUpdated: false,
                isUpdatingNow: false
            }
        };
        resellerService.getCustomers = function () {
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/resellers/'
            });
        };
        resellerService.getStats = function () {
            var self = this;
            // NOTE (Dec. 2019): All three widgets will trigger a load
            // TODO: Refactor to use NgRx and only load once!
            //if (self.viewModel.isUpdated || self.viewModel.isUpdatingNow) {
            //    return;
            //}
            self.viewModel.isUpdatingNow = true;
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/resellers/stats',
                disableErrorDialog: true
            })
                .then(function (reseller) {
                if (angular.isDefined(reseller.stats)) {
                    self.viewModel.stats.trialCust = reseller.stats["In Trial"];
                    self.viewModel.stats.payingCust = reseller.stats["Paying Customer"];
                }
                if (angular.isDefined(reseller.customercount) && reseller.customercount !== null) {
                    self.viewModel.stats.customerCount = reseller.customercount;
                }
                self.viewModel.isUpdatingNow = false;
                self.viewModel.isUpdated = true;
                return reseller;
            });
        };
        return resellerService;
    }]);
//# sourceMappingURL=reseller.services.js.map